import {
  QBox,
  QFormControl,
  QMultiSelect,
  QSelectPlaceholder,
  QText,
} from '@qualio/ui-components';
import { useMemo } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useTemplates } from '../../../hooks/useTemplates';
import { filterOptionBySearchText } from '../../../util/SelectionOptionUtils';
import { useInheritedTemplateOptions } from '../InheritedTemplateIcon/useInheritedTemplateOptions';

type TypesFilterFieldProps = {
  name: string;
  dataCy: string;
  includeArchived: boolean;
};

export const TypesFilterField = ({
  name,
  dataCy,
  includeArchived,
}: TypesFilterFieldProps) => {
  const { t } = useTranslation();
  const { data: templates = [], isLoading } = useTemplates({ includeArchived });

  const baseTemplatesOptions = useMemo(
    () =>
      templates.map((template) => ({
        value: template.prefix,
        label: template.name,
        code: template.prefix,
        properties: { id: template.id },
        parent: template.parent,
      })),
    [templates],
  );
  const templatesOptions = useInheritedTemplateOptions(baseTemplatesOptions);

  return (
    <QFormControl label={t('labels.type')} w="300px">
      <Controller
        name={name}
        render={({ field: { onChange, value, ...field } }) => (
          <QBox data-cy={dataCy}>
            <QMultiSelect
              {...field}
              options={templatesOptions}
              filterOption={filterOptionBySearchText}
              value={value ?? []}
              onChange={(val) => onChange(val.map((option) => option.value))}
              isClearable={true}
              isLoading={isLoading}
            >
              <QSelectPlaceholder>
                <QText>{t('forms.filterByType')}</QText>
              </QSelectPlaceholder>
            </QMultiSelect>
          </QBox>
        )}
      />
    </QFormControl>
  );
};
